type IsRouteProps = {
  pathname: string;
  routes: string[];
  trailingSlash?: boolean;
  startsWith?: boolean;
}
export const isRoute = ({ pathname, routes, trailingSlash = false, startsWith = false }: IsRouteProps) => {
  return routes.some(route =>
    pathname === route
    || (trailingSlash && pathname === `${route}/`)
    || (startsWith && pathname.startsWith(route))
  );
};
